const listeners = {};

export const globalEvent = {
  on: (event, callback) => {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(callback);
  },
  off: (event, callback) => {
    if (listeners[event]) {
      listeners[event] = listeners[event].filter((cb) => cb !== callback);
    }
  },
  emit: (event, data) => {
    if (listeners[event]) {
      listeners[event].forEach((cb) => cb(data));
    }
  },
};